import { render, staticRenderFns } from "./shopsupply.vue?vue&type=template&id=3f52403f&scoped=true"
import script from "./shopsupply.vue?vue&type=script&lang=js"
export * from "./shopsupply.vue?vue&type=script&lang=js"
import style0 from "./shopsupply.vue?vue&type=style&index=0&id=3f52403f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f52403f",
  null
  
)

export default component.exports